"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _consts = require("../consts");
var _httpClient = require("@wix/http-client");
var _ALBUMS$ALBUMS_APP_DE;
var httpClient = new _httpClient.HttpClient();
var wixProvidersArray = [_consts.ART_STORE.PROVIDERS.WIX, _consts.ART_STORE.PROVIDERS.LOCAL];
var getProviderId = function getProviderId(connectedProviders) {
  return connectedProviders[Object.keys(connectedProviders)[0]].providerId;
};
var fetchConnectedProvider = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(url) {
    var response, data, _ref2;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return httpClient.get(url);
        case 3:
          response = _context.sent;
          if (!(response.status === 200)) {
            _context.next = 8;
            break;
          }
          data = response.data;
          if (!(data && data.providerId)) {
            _context.next = 8;
            break;
          }
          return _context.abrupt("return", (_ref2 = {}, _ref2[data.providerId] = data, _ref2));
        case 8:
          _context.next = 13;
          break;
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
        case 13:
          return _context.abrupt("return", null);
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 10]]);
  }));
  return function fetchConnectedProvider(_x) {
    return _ref.apply(this, arguments);
  };
}();
var _default = exports["default"] = (_ALBUMS$ALBUMS_APP_DE = {}, _ALBUMS$ALBUMS_APP_DE[_consts.ALBUMS.ALBUMS_APP_DEF_ID] = {
  getAdditionalParams: function getAdditionalParams(_ref3) {
    var albumId = _ref3.albumId,
      pricelistId = _ref3.pricelistId,
      freeArtStore = _ref3.freeArtStore;
    return {
      srcId: albumId,
      pricelistId: pricelistId,
      appDefId: _consts.ALBUMS.ALBUMS_APP_DEF_ID,
      isAlbumStore: true,
      // TODO: should be removed after all providers supports this'
      freeArtStore: freeArtStore
    };
  },
  getConnectedProviders: function () {
    var _getConnectedProviders = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(instanceId, baseUrl) {
      var url;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            url = baseUrl + "/albums-node-server/getAlbumConnectedProvidersByArtStoreInstanceId?instanceId=" + instanceId;
            _context2.next = 3;
            return fetchConnectedProvider(url);
          case 3:
            return _context2.abrupt("return", _context2.sent);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function getConnectedProviders(_x2, _x3) {
      return _getConnectedProviders.apply(this, arguments);
    }
    return getConnectedProviders;
  }(),
  getInstanceFromSettings: function getInstanceFromSettings(settings) {
    return settings.albumId || settings.srcId;
  },
  getInvalidItemsForDownloadUrl: function getInvalidItemsForDownloadUrl(intanceId) {
    return "//progallery.wixapps.net/albums-node-server/api/itemsVerification?instanceId=" + intanceId;
  },
  getAdditionalQueryParams: function getAdditionalQueryParams(providerParams) {
    var appDefId = providerParams.appDefId,
      srcId = providerParams.srcId;
    return "srcId=" + srcId + "&appDefId=" + appDefId;
  },
  getSectionsUrlWithParams: function getSectionsUrlWithParams(baseSectionsUrl, providerParams, connectedProviders) {
    var providerId = getProviderId(connectedProviders);
    if (!wixProvidersArray.includes(providerId)) {
      var appDefId = providerParams.appDefId,
        srcId = providerParams.srcId;
      var thank_you_page = baseSectionsUrl.thank_you_page,
        checkout_page = baseSectionsUrl.checkout_page;
      var queryParams = "?srcId=" + srcId + "&appDefId=" + appDefId;
      return {
        thank_you_page: {
          url: thank_you_page.url + queryParams
        },
        checkout_page: {
          url: checkout_page.url + queryParams
        }
      };
    }
    return baseSectionsUrl;
  },
  getSiteBusinessPackageData: function () {
    var _getSiteBusinessPackageData = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(locale, srcId, baseUrl) {
      var url, response, retVal;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            url = baseUrl + "/albums-node-server/hasBusinessPackage?locale=" + locale + "&albumId=" + srcId;
            _context3.next = 3;
            return httpClient.get(url);
          case 3:
            response = _context3.sent;
            retVal = response.data;
            return _context3.abrupt("return", {
              hasBusinessPackage: retVal.result,
              metaSiteId: retVal.metaSiteIdForPackage
            });
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function getSiteBusinessPackageData(_x4, _x5, _x6) {
      return _getSiteBusinessPackageData.apply(this, arguments);
    }
    return getSiteBusinessPackageData;
  }(),
  getMotherSiteAppInstance: function () {
    var _getMotherSiteAppInstance = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(motherSiteMetaSiteId, baseUrl) {
      var _response$data;
      var url, response;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            url = baseUrl + "/albums-node-server/getAlbumConnectedProvidersByMotherSiteMetaSiteId?motherSiteMetaSiteId=" + motherSiteMetaSiteId;
            _context4.next = 3;
            return httpClient.get(url);
          case 3:
            response = _context4.sent;
            if (!((_response$data = response.data) != null && _response$data.signedInstance)) {
              _context4.next = 6;
              break;
            }
            return _context4.abrupt("return", response.data.signedInstance);
          case 6:
            return _context4.abrupt("return", null);
          case 7:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    function getMotherSiteAppInstance(_x7, _x8) {
      return _getMotherSiteAppInstance.apply(this, arguments);
    }
    return getMotherSiteAppInstance;
  }(),
  getSitebusinessPlanUrl: function getSitebusinessPlanUrl(metaSiteId) {
    return "https://www.wix.com/store/plans?siteGuid=" + metaSiteId + "&businessTab=true&referralAdditionalInfo=photoAlbums";
  }
}, _ALBUMS$ALBUMS_APP_DE[_consts.ART_STORE.ARTSTORE_APP_DEFINITION_ID] = {
  getAdditionalParams: function getAdditionalParams() {
    return {};
  },
  getAdditionalQueryParams: function getAdditionalQueryParams() {
    return '';
  },
  getInstanceFromSettings: function getInstanceFromSettings() {},
  getConnectedProviders: function () {
    var _getConnectedProviders2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(instance, baseUrl) {
      var url;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            url = baseUrl + "/pro-gallery-webapp/api/v1/store/providers?instance=" + instance + "&cache_buster=" + Math.random();
            _context5.next = 3;
            return fetchConnectedProvider(url);
          case 3:
            return _context5.abrupt("return", _context5.sent);
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    function getConnectedProviders(_x9, _x10) {
      return _getConnectedProviders2.apply(this, arguments);
    }
    return getConnectedProviders;
  }(),
  getSectionsUrlWithParams: function getSectionsUrlWithParams(baseSectionsUrl, _params, _connectedProviders) {
    return baseSectionsUrl;
  },
  getSiteBusinessPackageData: function getSiteBusinessPackageData() {},
  getSitebusinessPlanUrl: function getSitebusinessPlanUrl(_) {
    return '';
  }
}, _ALBUMS$ALBUMS_APP_DE);